import { render, staticRenderFns } from "./courseCover.vue?vue&type=template&id=bf78a208"
import script from "./courseCover.vue?vue&type=script&lang=js"
export * from "./courseCover.vue?vue&type=script&lang=js"
import style0 from "./courseCover.vue?vue&type=style&index=0&id=bf78a208&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports